import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lm-banner h-48 flex items-center justify-center flex-col" }
const _hoisted_2 = { class: "text-white font-semibold" }
const _hoisted_3 = { class: "font-body mt-2 text-white font-semi bold" }
const _hoisted_4 = { class: "lg:container lg:mx-auto pt-10 md:pt-12" }
const _hoisted_5 = { class: "px-4" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { class: "text-black-600" }
const _hoisted_8 = { class: "md:px-4" }
const _hoisted_9 = { class: "px-4" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "font-medium mb-1 mt-8" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-12 max-w-6xl\"><h4 class=\"font-bold\">About liquidity mining</h4><p class=\"mt-2\"> Many DeFi protocols distribute tokens to users who perform certain activities that help the network grow. Liquidity Mining aligns incentives between a protocol and its community by distributing voting power to the people who help create a more liquid market.<br><br>The Balancer Protocol, via the community Ballers, has allocated BAL tokens to go to Liquidity Providers in certain eligible pools (as listed in the tables above). Tokens are distributed proportional to the amount of liquidity each address contributed, relative to the total liquidity in eligible Balancer pools. BAL tokens give voting rights in community governance. In addition, other protocols may further incentivize liquidity by also distributing tokens to Balancer Liquidity Providers in certain pools. </p><div class=\"mt-6\"><h5>Liquidity mining details</h5><ul class=\"mt-2 pl-8 list-disc\"><li class=\"mt-2\"> You’re eligible to receive token distributions if you add liquidity to any of the eligible pools. </li><li class=\"mt-2\"> Liquidity mining weeks start and end at 00:00 UTC on Mondays. </li><li class=\"mt-2\"> BAL allocations and pool eligibility are determined weekly by the community ‘Ballers’. </li></ul></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LMTable = _resolveComponent("LMTable")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, "Week " + _toDisplayString(_ctx.currentWeek) + " Liquidity mining incentives", 1),
      _createElementVNode("h1", _hoisted_3, " ~" + _toDisplayString(_ctx.fNum2(_ctx.currentWeekTotalFiat, _ctx.FNumFormats.fiat)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, "Liquidity mining on " + _toDisplayString(_ctx.shortNetworkName), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.description), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_LMTable, {
          "is-loading": _ctx.isLoadingPools || _ctx.isLoadingPoolsIdle,
          poolMetadata: _ctx.pools,
          weeks: _ctx.weeks,
          totals: _ctx.totals
        }, null, 8, ["is-loading", "poolMetadata", "weeks", "totals"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, "Liquidity Mining is also on " + _toDisplayString(_ctx.otherNetwork), 1),
          _createVNode(_component_BalLink, { external: "" }, {
            default: _withCtx(() => [
              _createElementVNode("a", { href: _ctx.otherNetworkLink }, [
                _createElementVNode("div", _hoisted_13, [
                  _createTextVNode(" View " + _toDisplayString(_ctx.otherNetwork) + " liquidity mining incentives ", 1),
                  _createVNode(_component_BalIcon, { name: "arrow-right" })
                ])
              ], 8, _hoisted_12)
            ]),
            _: 1
          })
        ]),
        _hoisted_14
      ])
    ])
  ]))
}